import { a as g } from "@theme/theme";
import { g as getViewedProductHandles, r as removeViewedProduct } from "@theme/viewed-products";
class SuggestedProductsComponent extends window.HTMLElement {
  constructor() {
    super();
    this.DOM = {
      productsGrid: this.querySelector(".js-products-grid"),
      viewedTitle: this.querySelector(".js-viewed-title"),
      interestedTitle: this.querySelector(".js-interested-title")
    };
  }
  connectedCallback() {
    this.loadProducts();
  }
  async loadProducts() {
    const cartHandles = await this.getCartHandles();
    let handles = this.filterCartProducts(getViewedProductHandles(), cartHandles);
    if (handles.length === 0) {
      handles = await this.getRandomProducts(cartHandles, 3);
      this.DOM.interestedTitle.hidden = false;
    } else {
      this.DOM.viewedTitle.hidden = false;
    }
    if (handles.length === 0) {
      this.hidden = true;
      return;
    }
    this.renderProducts(handles);
  }
  async renderProducts(handles) {
    try {
      const renderPromises = handles.map(
        (handle) => fetch(`/products/${handle}?section_id=suggested-product-render`).then((res) => {
          if (!res.ok) throw new Error(`Product ${handle} not found`);
          return res.text();
        }).catch((err) => {
          console.error(`Error loading product ${handle}:`, err);
          return "";
        })
      );
      const htmls = await Promise.all(renderPromises);
      this.DOM.productsGrid.innerHTML = htmls.join("");
      new g({
        elements_selector: ".js-lazy"
      });
    } catch (error) {
      console.error("Error loading suggested products:", error);
    }
  }
  async getCartHandles() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      return new Set(cart.items.map((item) => item.handle));
    } catch {
      return /* @__PURE__ */ new Set();
    }
  }
  filterCartProducts(handles, cartHandles) {
    handles.forEach((h) => cartHandles.has(h) && removeViewedProduct(h));
    return handles.filter((h) => !cartHandles.has(h));
  }
  async getRandomProducts(cartHandles, count) {
    try {
      const res = await fetch("/products.json?limit=50");
      const { products } = await res.json();
      const available = products.map((p) => p.handle).filter((h) => !cartHandles.has(h));
      for (let i = available.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [available[i], available[j]] = [available[j], available[i]];
      }
      return available.slice(0, count);
    } catch (error) {
      console.error("Error fetching random products:", error);
      return [];
    }
  }
}
window.customElements.define("c-suggested-products", SuggestedProductsComponent);
